import React from 'react';
import {
  removeSignificanceCriteriaVariant,
  setSignificanceVariant,
} from '../../../../../../../redux/slices/oldBuilder';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../../../redux/hooks';
import { significanceCriteriaSelector } from '../../../../../../../redux/selectors/builder';
import {
  assertCondition,
  assertNotNil,
} from '../../../../../../../utils/types';
import { MAX_SIGNIFICANCE_VARIANTS } from '../../../../../../../config/constants';
import { SignificanceModeKey } from '../../../../../../../utils/apollo/graphqlSchema';
import AddVariantAction from '../../SignificanceVariants/AddVariantAction';
import SignificanceBreakdownVariant from './SignificanceBreakdownVariant';

const SignificanceBreakdownVariants = () => {
  const dispatch = useAppDispatch();

  const significanceCriteria = useAppSelector(significanceCriteriaSelector);
  assertCondition(
    significanceCriteria?.modeKey === SignificanceModeKey.Breakdown,
  );
  const { field, variants } = significanceCriteria;
  assertNotNil(field);

  const handleSetVariant = (value: string | null, variantIndex: number) => {
    dispatch(
      setSignificanceVariant({
        modeKey: significanceCriteria.modeKey,
        variant: value,
        variantIndex,
      }),
    );
  };
  const handleAddVariant = () => {
    handleSetVariant(null, variants.length);
  };
  const handleRemoveVariant = (variantIndex: number) => {
    dispatch(removeSignificanceCriteriaVariant({ variantIndex }));
  };

  const allowAddVariants = variants.length < MAX_SIGNIFICANCE_VARIANTS;

  return (
    <>
      {variants.map((variant, variantIndex) => (
        <SignificanceBreakdownVariant
          key={`variant-${variantIndex}`}
          field={field}
          variant={variant}
          variantIndex={variantIndex}
          onChange={handleSetVariant}
          onRemove={handleRemoveVariant}
          allowRemove={!allowAddVariants}
        />
      ))}
      {allowAddVariants && <AddVariantAction onClick={handleAddVariant} />}
    </>
  );
};

export default SignificanceBreakdownVariants;
